import React from "react";
import {Form} from "antd";
import {TextField, TextFieldProps} from "@reside/ui";

import {LabelAttribute} from "../label-attribute";
import {DisabledAttribute} from "../disabled-attribute";
import {RequiredAttribute} from "../required-attribute";
import {
  getInitialMinLengthFormValue,
  MinLengthAttribute,
} from "../min-length-attribute";
import {
  getInitialMaxLengthFormValue,
  MaxLengthAttribute,
} from "../max-length-attribute";
import {AtomProp, useFocusedNode} from "../../model/editor";
import {DisableClick} from "../disable-click";
import {FormControlSourceNode} from "../../model/schemaTypes";

export const EditableTextField = ({
  atom,
  ...props
}: AtomProp & TextFieldProps) => (
  <DisableClick>
    <TextField {...props} />
  </DisableClick>
);

/**
 * FormControl type-specific form to adjust attributes.
 */
export const TextFieldForm = () => {
  const node = useFocusedNode() as FormControlSourceNode;

  return (
    <Form
      key={node.id}
      initialValues={{
        label: node?.reference?.translationKey,
        ...getInitialMinLengthFormValue(node),
        ...getInitialMaxLengthFormValue(node),
      }}
    >
      <LabelAttribute />
      <MinLengthAttribute />
      <MaxLengthAttribute />
      <DisabledAttribute />
      <RequiredAttribute />
    </Form>
  );
};
